export const environment = {
  production: true,
  orderServiceUrl: 'https://orders.twikit.com',
  pluginUrl: 'https://sites.twikit.com/decathlon/production/plugin-script.js',
  configurationsUrl: 'https://configurations.twikit.com',
  spaceKey: 'decathlon',
  flowKey: 'default',
  productKey: 'handle_bars'
};
